import { useEffect, useState } from 'react'

export const MOBILE_WIDTH = 767

// use for tablet check
export const TABLET_WIDTH = 1023

export const useIsMobile = (mobileWidth = MOBILE_WIDTH) => {
    const [isMobile, setIsMobile] = useState<boolean>(false)

    const updateOnResize = () => {
        setIsMobile(window.innerWidth <= mobileWidth)
    }

    useEffect(() => {
        updateOnResize()
        window.addEventListener('resize', updateOnResize, false)
        return () => window.removeEventListener('resize', updateOnResize, false)
    }, [])

    return isMobile
}
